import { Check } from "lucide-react";

interface VerifiedBadgeProps {
  label?: string;
  compact?: boolean;
}

export default function VerifiedBadge({
  label = "ID Verified",
  compact = false,
}: VerifiedBadgeProps) {
  return (
    <span
      className="inline-flex items-center rounded-full bg-white"
      title={label}
    >
      <span
        className={`inline-flex shrink-0 items-center justify-center rounded-full border-2 border-amber-400 bg-white ${
          compact ? "h-5 w-5" : "h-6 w-6"
        }`}
        aria-hidden="true"
      >
        <span
          className={`inline-flex items-center justify-center bg-indigo-600 text-white ${
            compact ? "h-3.5 w-3.5" : "h-4 w-4"
          }`}
          style={{
            clipPath:
              "polygon(50% 0%, 58% 12%, 71% 7%, 76% 21%, 90% 21%, 88% 36%, 100% 45%, 90% 55%, 95% 69%, 80% 72%, 76% 87%, 62% 81%, 50% 100%, 38% 81%, 24% 87%, 20% 72%, 5% 69%, 10% 55%, 0% 45%, 12% 36%, 10% 21%, 24% 21%, 29% 7%, 42% 12%)",
          }}
        >
          <Check className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} strokeWidth={4} />
        </span>
      </span>
    </span>
  );
}
